import React from "react";
import {
  FaFacebookF,
  FaYoutube,
  FaInstagram,
  FaLinkedinIn,
  FaHeadset,
  FaPhone,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { EnvelopeIcon } from "@heroicons/react/24/outline";
import logo from "../assets/logo1.png";
import { Link, useNavigate } from "react-router-dom";
import fonepayLogo from "../assets/fonepay.png";

const Footer = () => {
  const navigate = useNavigate();

  const handleFonepayClick = () => {
    navigate("/fonepay");
  };

  return (
    <footer className="bg-blue-950 text-white py-8 border-t border-gray-700">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6">
        {/* Main Footer Sections */}
        <div className="grid grid-cols-1 md:grid-cols-[1fr,1fr,1.4fr,0.8fr] gap-3 md:gap-8 text-center md:text-left footer-grid">
          {/* Left Section - Logo and Tagline */}
          <div className="flex flex-col items-center md:items-start gap-3 footer-logo-container">
            <Link to="/">
              <img
                src={logo}
                alt="Virtueista IT logo"
                className="w-28 h-auto object-contain filter bg-transparent"
              />
            </Link>
            <p className="text-gray-300 text-sm md:text-base leading-none">Pathway to Excellence</p>
          </div>

          {/* Middle Section - Helpful Links */}
          <div className="space-y-3">
            <h3 className="font-semibold text-lg">HELPFUL LINKS</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/courses"
                  className="text-blue-400 hover:underline hover:text-yellow-400 text-sm md:text-base transition-colors duration-200"
                >
                  Courses
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-blue-400 hover:underline hover:text-yellow-400 text-sm md:text-base transition-colors duration-200"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/refund-policy"
                  className="text-blue-400 hover:underline hover:text-yellow-400 text-sm md:text-base transition-colors duration-200"
                >
                  Refund Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms-conditions"
                  className="text-blue-400 hover:underline hover:text-yellow-400 text-sm md:text-base transition-colors duration-200"
                >
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>

          {/* Right Section - Contact Information */}
          <div className="space-y-3">
            <h3 className="font-semibold text-lg">GET IN TOUCH</h3>
            <ul className="space-y-3">
              <li className="flex items-center justify-center md:justify-start space-x-2 text-gray-300 text-sm md:text-base">
                <EnvelopeIcon className="w-4 h-4" />
                <a href="mailto:virtueistait@gmail.com">virtueistait@gmail.com</a>
              </li>
              <li className="flex items-center justify-center md:justify-start space-x-2 text-gray-300 text-sm md:text-base">
                <FaPhone className="w-4 h-4" />
                <span>+977-9849489441</span>
              </li>
              <li className="flex items-center justify-center md:justify-start space-x-2 text-gray-300 text-sm md:text-base">
                <FaMapMarkerAlt className="w-4 h-4" />
                <span>Traffic Chowk, Biratnagar-10</span>
              </li>
              <li className="flex items-center justify-center md:justify-start space-x-2 text-gray-300 text-sm md:text-base">
                <FaHeadset className="w-4 h-4" />
                <span>Support Team: 10am-5pm [Sun-Fri]</span>
              </li>
            </ul>
          </div>

          {/* Right-Aligned Social Media Section */}
          <div className="space-y-3">
            <h3 className="font-semibold text-lg">CONNECT WITH US</h3>
            <div className="flex flex-col items-center md:items-start space-y-3">
              <a
                href="https://www.facebook.com/share/1Af3rMDnxf/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-blue-400 hover:text-yellow-400 text-sm md:text-base transition-colors duration-200"
              >
                <FaFacebookF className="w-4 h-4" />
                <span>Facebook</span>
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-red-500 hover:text-yellow-400 text-sm md:text-base transition-colors duration-200"
              >
                <FaYoutube className="w-4 h-4" />
                <span>YouTube</span>
              </a>
              <a
                href="https://www.instagram.com/virtueista_it?igsh=d3RmbXVpOGtqMWll"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-pink-500 hover:text-yellow-400 text-sm md:text-base transition-colors duration-200"
              >
                <FaInstagram className="w-4 h-4" />
                <span>Instagram</span>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-blue-400 hover:text-yellow-400 text-sm md:text-base transition-colors duration-200"
              >
                <FaLinkedinIn className="w-4 h-4" />
                <span>LinkedIn</span>
              </a>
            </div>
          </div>
        </div>

        {/* Copyright and Payment Section */}
        <div className="pt-6 flex flex-col items-center space-y-4">
          {/* Copyright Section */}
          <p className="text-sm md:text-base text-white font-medium">
            Copyright © 2025. Virtueista IT Pvt. Ltd.
          </p>

          {/* Payment Section */}
          <div className="flex items-center space-x-3">
            <span className="text-sm md:text-base text-gray-300 font-medium">We Accept:</span>
            <img
              src={fonepayLogo}
              alt="Fonepay Logo"
              className="h-8 bg-white rounded-md shadow-md hover:shadow-xl hover:scale-105 transition-all duration-300 cursor-pointer"
              onClick={handleFonepayClick}
            />
          </div>
        </div>
      </div>

      {/* Inline CSS to Prevent Logo Stretching and Adjust Spacing */}
      <style>
        {`
          .object-contain {
            object-fit: contain;
          }
          .leading-none {
            line-height: 1;
          }
          @media (max-width: 767px) {
            .footer-grid {
              gap: 40px !important;
            }
            .footer-logo-container img {
              width: 7rem !important;
              height: auto !important;
              object-fit: contain !important;
              margin: 0 !important;
              padding: 0 !important;
            }
            .footer-logo-container p {
              margin: 0 !important;
              padding: 0 !important;
              line-height: 1 !important;
              font-size: 1rem !important; /* Align tagline with body text */
            }
            .footer-logo-container {
              margin: 0 !important;
              padding: 0 !important;
            }
          }
        `}
      </style>
    </footer>
  );
};

export default Footer;
